import { render, staticRenderFns } from "./FileImport.vue?vue&type=template&id=35859f96&scoped=true"
import script from "./FileImport.vue?vue&type=script&lang=js"
export * from "./FileImport.vue?vue&type=script&lang=js"
import style0 from "./FileImport.vue?vue&type=style&index=0&id=35859f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35859f96",
  null
  
)

export default component.exports